"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _currency = require("../../../utils/currency");

var _Bubble = _interopRequireDefault(require("../../Bubble"));

var _NonRefundableCancellation = _interopRequireDefault(require("../../../icons-react/userflow/NonRefundableCancellation"));

var _FreeCancellation = _interopRequireDefault(require("../../../icons-react/userflow/FreeCancellation"));

var _PartialCancellation = _interopRequireDefault(require("../../../icons-react/userflow/PartialCancellation"));

var _CancelledCancellation = _interopRequireDefault(require("../../../icons-react/userflow/CancelledCancellation"));

var _utils = require("../assets/utils");

var CollapsedCancellationPolicy = function CollapsedCancellationPolicy(_ref) {
  var returnType = _ref.returnType,
      currentStageEndDateISO = _ref.currentStageEndDateISO,
      isMobile = _ref.isMobile,
      hasInsurance = _ref.hasInsurance,
      _ref$onGetInsuranceCl = _ref.onGetInsuranceClick,
      onGetInsuranceClick = _ref$onGetInsuranceCl === void 0 ? function () {
    return null;
  } : _ref$onGetInsuranceCl,
      insuranceSelected = _ref.insuranceSelected,
      _ref$onDetailsClick = _ref.onDetailsClick,
      onDetailsClick = _ref$onDetailsClick === void 0 ? function () {
    return null;
  } : _ref$onDetailsClick,
      insurancePrice = _ref.insurancePrice,
      isCollapsed = _ref.isCollapsed,
      showPopup = _ref.showPopup,
      isSmall = _ref.isSmall,
      PopupComponent = _ref.PopupComponent,
      cancelled = _ref.cancelled,
      isHotelOnly = _ref.isHotelOnly,
      mobileCollapsedElRef = _ref.mobileCollapsedElRef;

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  var insuranceBtnText = !insuranceSelected ? /*#__PURE__*/_react["default"].createElement(StyledInsurance, null, t('cancellationPolicy.insuranceAdd', {
    context: isMobile ? 'mobile' : 'desktop'
  }), ' ', (0, _currency.formatCurrency)(insurancePrice || 0)) : /*#__PURE__*/_react["default"].createElement(StyledInsurance, null, t('cancellationPolicy.insuranceRemove', {
    context: isMobile ? 'mobile' : 'desktop'
  }));

  var getIconForReturnType = function getIconForReturnType() {
    if (cancelled) return /*#__PURE__*/_react["default"].createElement(_CancelledCancellation["default"], null);

    switch (returnType) {
      case 'full':
        return /*#__PURE__*/_react["default"].createElement(_FreeCancellation["default"], null);

      case 'partial':
        return /*#__PURE__*/_react["default"].createElement(_PartialCancellation["default"], null);

      case 'nothing':
        return /*#__PURE__*/_react["default"].createElement(_NonRefundableCancellation["default"], null);

      default:
        return null;
    }
  };

  var showInsuranceButton = hasInsurance && isCollapsed && !isSmall;
  var icon = getIconForReturnType();
  var collapsedTitleContent = (0, _utils.getCollapsedTitleContent)(isMobile, isHotelOnly, returnType, currentStageEndDateISO, cancelled);
  var handleClick = showPopup ? function () {
    return null;
  } : onDetailsClick;

  var UncollapseButton = /*#__PURE__*/_react["default"].createElement(StyledUncollapseButton, {
    isMobile: isMobile,
    onClick: handleClick,
    isSmall: isSmall
  }, ' ', t('checkout.extraRooms.more'));

  var UncollapseComponent = showPopup ? /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    renderExtras: function renderExtras() {
      return PopupComponent;
    },
    text: " ",
    width: "max",
    eventType: "click"
  }, UncollapseButton) : UncollapseButton;
  return /*#__PURE__*/_react["default"].createElement(StyledCancellationPolicyWrapper, {
    ref: mobileCollapsedElRef
  }, /*#__PURE__*/_react["default"].createElement(StyledCollapsedCancellationPolicy, {
    isMobile: isMobile,
    isSmall: isSmall
  }, /*#__PURE__*/_react["default"].createElement(StyledCollapedContent, {
    isMobile: isMobile
  }, returnType === 'full' && !cancelled ? /*#__PURE__*/_react["default"].createElement(StyledFullRefundIcon, null, icon) : /*#__PURE__*/_react["default"].createElement(StyledIcon, null, icon), /*#__PURE__*/_react["default"].createElement(StyledCollapsedTextPart, {
    className: "cancellation-policy__text-part"
  }, /*#__PURE__*/_react["default"].createElement(StyledCollapsedTitle, {
    isMobile: isMobile,
    isSmall: isSmall
  }, collapsedTitleContent), isCollapsed ? UncollapseComponent : null)), showInsuranceButton ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
    isMobile: isMobile,
    onClick: onGetInsuranceClick
  }, insuranceBtnText) : null));
};

var StyledInsurance = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledInsurance",
  componentId: "sc-3cdug4-0"
})(["white-space:pre-line;"]);

var StyledCancellationPolicyWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledCancellationPolicyWrapper",
  componentId: "sc-3cdug4-1"
})(["display:flex;flex-direction:column;"]);

var StyledCollapsedCancellationPolicy = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledCollapsedCancellationPolicy",
  componentId: "sc-3cdug4-2"
})(["display:flex;flex-direction:column;"]);

var StyledCollapsedTitle = _styledComponents["default"].span.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledCollapsedTitle",
  componentId: "sc-3cdug4-3"
})(["display:block;font-style:normal;font-weight:normal;font-size:", ";line-height:", ";color:#4d4d4d;", ""], function (props) {
  return props.isMobile || props.isSmall ? '14px' : '18px';
}, function (props) {
  return props.isMobile || props.isSmall ? '16px' : '22px';
}, function (_ref2) {
  var isMobile = _ref2.isMobile,
      isSmall = _ref2.isSmall;
  return !isMobile && !isSmall && 'margin-bottom: 2px';
});

var StyledCollapedContent = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledCollapedContent",
  componentId: "sc-3cdug4-4"
})(["display:flex;", ""], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? null : 'margin-bottom: 4px;';
});

var StyledIcon = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledIcon",
  componentId: "sc-3cdug4-5"
})(["height:23px;svg{width:24px;height:24px;margin:9px 0px 0px 4px;transform:translate(0px,-6px) scale(1.33);}"]);

var StyledFullRefundIcon = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledFullRefundIcon",
  componentId: "sc-3cdug4-6"
})(["margin:0 8px 0 4px;svg{height:16px;transform:translate(5px,7px) scale(1.66);}"]);

var StyledCollapsedTextPart = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledCollapsedTextPart",
  componentId: "sc-3cdug4-7"
})(["margin-left:12px;"]);

var StyledUncollapseButton = _styledComponents["default"].span.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledUncollapseButton",
  componentId: "sc-3cdug4-8"
})(["font-family:Backpack;font-style:normal;font-weight:normal;font-size:", ";line-height:16px;color:#007aff;cursor:pointer;display:inline;"], function (props) {
  return props.isMobile || props.isSmall ? '12px' : '14px';
});

var StyledButton = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledButton",
  componentId: "sc-3cdug4-9"
})(["border:1px solid ", ";color:", ";box-sizing:border-box;border-radius:", ";padding:10px;margin-top:8px;font-size:", ";line-height:", ";text-align:center;", ""], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.blue;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.blue;
}, function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile ? '2px' : '4px';
}, function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile ? '16px' : '14px';
}, function (_ref8) {
  var isMobile = _ref8.isMobile;
  return isMobile ? '20px' : '16px';
}, function (props) {
  return !props.isMobile && "align-self: flex-start; \n     cursor: pointer; \n     transition: \n     opacity 200ms; \n     &:hover { \n       opacity: 0.8;\n    }";
});

var _default = CollapsedCancellationPolicy;
exports["default"] = _default;